
import React from 'react';
import { IconButton } from '@mui/material';
import "../../../assets/css/GoogleMapsControls.css";

interface MapCustomControlsProps {
  mapType?: string;
  onChangeMapType?: (type: string) => void;
  onZoomIn?: () => void;
  onZoomOut?: () => void;
}

const MapCustomControls: React.FC<MapCustomControlsProps> = ({
  mapType = 'roadmap',
  onChangeMapType,
  onZoomIn = () => {},
  onZoomOut = () => {},
}) => {

  const handleMapTypeChange = (newMapType: string) => {
    if (onChangeMapType) {
      onChangeMapType(newMapType);
    }
  };

  const handleZoomIn = (event: React.MouseEvent) => {
    event.preventDefault();
    if (onZoomIn) {
      onZoomIn();
    }
  };

  const handleZoomOut = (event: React.MouseEvent) => {
    event.preventDefault();
    if (onZoomOut) {
      onZoomOut();
    }
  };



  return (
    <>
      <span className="custom-gmap-control zoom-control">
        <div className="zoom-control-btn-wrapper">
          <div className="zoom-control-btn" data-testid="map-zoom-in-btn">
            <IconButton
              onClick={handleZoomIn}
              data-testid="map-zoom-in-btn"
              className="zoom-control-btn zoom-in-btn"
              disableRipple
              disableFocusRipple
              disableTouchRipple
              sx={{
                '&:focus': { outline: 'none' },
                '&:active': { outline: 'none' },
                '&:hover': { backgroundColor: 'transparent' },
              }}
            >
              <img src={'/zoom-in.svg'} alt='Zoom In' />
            </IconButton>
          </div>
          <div className="zoom-control-btn" data-testid="map-zoom-out-btn">
            <IconButton
              onClick={handleZoomOut}
              data-testid="map-zoom-out-btn"
              className="zoom-control-btn zoom-out-btn"
              disableRipple
              disableFocusRipple
              disableTouchRipple
              sx={{
                '&:focus': { outline: 'none' },
                '&:active': { outline: 'none' },
                '&:hover': { backgroundColor: 'transparent' },
              }}
            >
              <img src={'/zoom-out.svg'} alt='Zoom Out' />
            </IconButton>
          </div>
        </div>
      </span>

      <span className="custom-gmap-control map-type-control">
        <div className='gmap-control-btn-wrapper'>
          <div className='gmap-control-btn'>
            <IconButton
              onClick={() => handleMapTypeChange('roadmap')}
              data-testid="map-roadmap-btn"
              className="btn custom-gmap-control-btn"
              disableRipple
              disableFocusRipple
              disableTouchRipple
              sx={{
                '&:focus': { outline: 'none' },
                '&:active': { outline: 'none' },
                '&:hover': { backgroundColor: 'transparent' },
              }}
            >
              <img src={mapType === 'roadmap' ? '/map-active.svg' : '/map-default.svg'} alt='Roadmap View' />
            </IconButton>
          </div>

          <div className='gmap-control-btn'>
            <IconButton
              onClick={() => handleMapTypeChange('hybrid')}
              data-testid="map-hybrid-btn"
              className="btn custom-gmap-control-btn"
              disableRipple
              disableFocusRipple
              disableTouchRipple
              sx={{
                '&:focus': { outline: 'none' },
                '&:active': { outline: 'none' },
                '&:hover': { backgroundColor: 'transparent' },
              }}
            >
              <img src={mapType === 'hybrid' ? '/map-hybrid-active.svg' : '/map-hybrid-default.svg'} alt='Hybrid View' />
            </IconButton>
          </div>
        </div>
      </span>

    </>
  );
};

export { MapCustomControls };
